import styled from 'styled-components';
import { breakpoints } from '../../ui/variables';

// import { colors, fontFamily } from '../../ui/variables';

export const InstitutionListStyle = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .institutions-list-table-head {
    margin-top: 40px;
    margin-bottom: 16px;
    display: none;
    padding-left: 125px;
    padding-right: 31px;

    @media (min-width: 1370px) {
      display: flex;
      justify-content: flex-start;
      width: 100%;
      max-height: 100%;
      opacity: 1;

      transition: opacity 1000ms;

      &.selected {
        opacity: 0;
        transition: opacity 100ms;
      }
    }

    .institution-name-item {
      width: 24%;
    }

    .registration-item {
      width: 20%;
    }

    .exams-item {
      width: 20%;
    }

    .administrator-item {
      width: 20%;
    }

    .actions-item {
      width: 6%;
    }
  }

  .institutions-list-data {
    margin-top: 30px;
    border-radius: 19px;
    width: 100%;
    min-width: 250px;
    position: relative;

    &.selected {
      display: grid;
      grid-template-columns: 1fr;
      grid-gap: 0.5%;
      @media (min-width: ${breakpoints.ipadLandscape.width}px) {
        grid-template-columns: 1fr 1fr;
        grid-gap: 3%;
      }

      @media (min-width: ${breakpoints.wxgaPlus.width}px) {
        grid-template-columns: 1fr 1fr 1fr;
      }
    }
  }

  .warning {
    width: 100%;
  }
`;
